<template>
  <i
    class="status-icon pi"
    :class="ok ? 'pi-check-circle status-icon--ok' : 'pi-times-circle status-icon--bad'"
    v-tooltip="title"
  />
</template>

<script>
export default {
  props: {
    ok: Boolean,
    title: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped>
.status-icon {
  font-size: 1rem;
}
.status-icon--ok {
  color: #059669;
}
.status-icon--bad {
  color: #dc2626;
}
</style>
